export function convertFun (e) {
  const value = parseFloat(e)
  let str = ''
  if ((value >= 0) && (value <= 22.5)) {
    str = '北风'
  } else if ((value > 22.5) && (value < 67.5)) {
    str = '东北风'
  } else if ((value >= 67.5) && (value <= 112.5)) {
    str = '东风'
  } else if ((value > 112.5) && (value < 157.5)) {
    str = '东南风'
  } else if ((value >= 157.5) && (value <= 202.5)) {
    str = '南风'
  } else if ((value > 202.5) && (value < 247.5)) {
    str = '西南风'
  } else if ((value >= 247.5) && (value <= 292.5)) {
    str = '西风'
  } else if ((value > 292.5) && (value < 337.5)) {
    str = '西北风'
  } else if ((value >= 337.5) && (value <= 360)) {
    str = '北风'
  } else {
    str = ''
  }
  return str
}
